import Yup from '~/utils/validations/yup';

export const recoveryPasswordSchemaValidation = Yup.object({
  password: Yup.string().min(6).password(),
});
